import styles from './ServiceNumber.module.css';

const ServiceNumber = props => {
  return (
    <span className={styles.number}>{props.children}</span>
  );
};

export default ServiceNumber;